/**
 * Convercus BI Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TrendTileSettingsDto } from './trend-tile-settings-dto';
import { FilterBindingDto } from './filter-binding-dto';
import { TileLocalizedTitleDto } from './tile-localized-title-dto';


export interface UpdateItemDto { 
    /**
     * Pin a specific KPI version. Omit to keep serving the KPI\'s published version.
     */
    kpiVersionId?: string;
    /**
     * Sort order for this item within the dashboard.
     */
    order?: number;
    /**
     * Optional display title for this dashboard item, in English; falls back to the localized KPI title.
     */
    titleOverride?: string;
    /**
     * The tile\'s title override in languages other than English, keyed by two-letter lowercase language code, at most 20 languages, for example {\"de\": {\"titleOverride\": \"Neue Mitglieder\"}, \"cs\": {\"titleOverride\": \"Noví členové\"}}. English goes in the plain titleOverride; an en key is rejected. A client shows the entry for the viewer\'s language, else the plain titleOverride. Omitted keeps the stored translations, null removes them, an object replaces the whole map. A new titleOverride should come with the new translations, so the old ones do not go stale.
     */
    i18n?: { [key: string]: TileLocalizedTitleDto; } | null;
    /**
     * Visibility status for this dashboard item.
     */
    status?: UpdateItemDto.StatusEnum;
    /**
     * Freeform tile layout state owned by the UI. Replaces the tile\'s whole layout, including `presentation` (chart type, stacked, hidden series), so send the current layout with your change merged in.
     */
    layout?: { [key: string]: any; };
    /**
     * Mappings from dashboard filters to KPI parameters for this tile.
     */
    filterBindings?: Array<FilterBindingDto>;
    /**
     * Trend tiles only: what the tile compares with. Null resets it to [previous_period]; omit it to keep the current setting.
     */
    trend?: TrendTileSettingsDto | null;
}
export namespace UpdateItemDto {
    export const StatusEnum = {
        Visible: 'visible',
        Hidden: 'hidden'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


